module.exports = __webpack_public_path__ + "media/images/logo_32-62e8d493.png";